import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Layout } from 'antd'

import Navbar from '../components/Navbar'
import Webcam from '../components/Webcam'
import FaceRect from '../components/FaceRect'
import Footer from '../components/Footer'
import requests from '../services/requests'

const { Content } = Layout

const INITIAL_STATE = {
  event: null,
  faces: [],
}

class Checkpoint extends Component {
  state = INITIAL_STATE
  componentWillMount() {
    this.setState({ event: this.props.event })
  }
  async componentDidMount() {
    const { event } = this.state
    try {
      await requests.get(`/event/${event.id}/train`)
    } catch (err) {
      console.error(err)
    }
  }
  async handleWebcam(image) {
    const { event } = this.state
    try {
      const faces = await requests.post(`/event/${event.id}/identify${this.props.location.search}`, { image })
      this.setState({ faces })
    } catch (err) {
      console.error(err)
      this.setState({ faces: [] })
    }
  }
  render() {
    return (
      <Layout className="layout">
        <Navbar event={this.state.event} selected="4" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{
            background: '#fff',
            padding: 24,
            minHeight: 'calc(100vh - 64px - 69px)',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          >
            <div style={{ position: 'relative', textAlign: 'center' }}>
              <Webcam
                onCapture={image => this.handleWebcam(image)}
                interval={this.state.event.interval || 1000}
                width={1280}
                height={720}
              />
              {this.state.faces.map(({ faceId, faceRectangle, person }) => (
                <FaceRect
                  key={faceId}
                  label={(person && person.name) || 'Unknow'}
                  faceId={faceId}
                  {...faceRectangle}
                />
              ))}
            </div>
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
Checkpoint.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    personGroupId: PropTypes.string,
    interval: PropTypes.number,
  }),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
}
Checkpoint.defaultProps = {
  event: {
    interval: 200,
  },
}

export default Checkpoint



// WEBPACK FOOTER //
// ./src/pages/Checkpoint.js